import React, { useEffect, useState } from 'react';
import { motion, useScroll, useMotionValueEvent } from 'framer-motion';
import { Menu, X } from 'lucide-react';
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const {
    scrollY
  } = useScroll();
  useMotionValueEvent(scrollY, 'change', latest => {
    setIsScrolled(latest > 50);
  });
  const navLinks = [{
    name: 'How It Works',
    href: '#how-it-works'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'Pricing',
    href: '#retainers'
  }, {
    name: 'Team',
    href: '#team'
  }];
  return <motion.nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-paper/95 backdrop-blur-sm border-b border-ink/5 py-4' : 'bg-transparent py-6'}`} initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.5
  }} data-id="element-96">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-97">
        <div className="flex justify-between items-center" data-id="element-98">
          {/* Logo */}
          <a href="#" className="flex items-center" data-id="element-99">
            <img src="https://cdn.magicpatterns.com/uploads/eMfWtjHpDD7x9U2JTU6YmP/TheSprintStudio_Logo_(2).png" alt="The Sprint Studio" className="h-8 w-auto" data-id="element-100" />
          </a>

          {/* Desktop Links */}
          <div className="hidden md:flex items-center space-x-10" data-id="element-101">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-normal text-ink/70 hover:text-ink transition-colors" data-id="element-102">
                {link.name}
              </a>)}
            <a href="#contact" className="bg-ink text-white px-6 py-2.5 text-sm font-medium hover:bg-ink/90 transition-colors" data-id="element-103">
              Start a Project
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button className="md:hidden p-2 text-ink" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-104">
            {isMobileMenuOpen ? <X size={24} data-id="element-105" /> : <Menu size={24} data-id="element-106" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <motion.div initial={{
      opacity: 0,
      height: 0
    }} animate={{
      opacity: 1,
      height: 'auto'
    }} exit={{
      opacity: 0,
      height: 0
    }} className="md:hidden bg-paper border-t border-ink/5" data-id="element-107">
          <div className="px-6 pt-4 pb-8 space-y-4 flex flex-col" data-id="element-108">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-base font-normal text-ink py-2 border-b border-ink/5" onClick={() => setIsMobileMenuOpen(false)} data-id="element-109">
                {link.name}
              </a>)}
            <div className="pt-4" data-id="element-110">
              <a href="#contact" className="block bg-ink text-white px-6 py-3 text-center text-sm font-medium hover:bg-ink/90 transition-colors" onClick={() => setIsMobileMenuOpen(false)} data-id="element-111">
                Start a Project
              </a>
            </div>
          </div>
        </motion.div>}
    </motion.nav>;
}